export function renderNestedListDefaultValueContentTemplate({
  fName,
  dataSource,
  join
}: {
  fName: string
  dataSource: string
  join: string
}): string {
  return `      ${fName}: (${dataSource}?.${fName} ?? []).map((item) => ({
${join}
      }))`
}
